const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { MediaUpload, InspectorControls, RichText } = wp.blockEditor;
const { useSelect } = wp.data;
const { TextControl, Panel, PanelBody, PanelRow, Icon, TextareaControl, Button } =
	wp.components;
const { serverSideRender: ServerSideRender } = wp;
import { useState } from "react";

const { __experimentalLinkControlSearchInput: LinkControlSearchInput } =
	wp.blockEditor;

registerBlockType(
	"qteblocks/post-pink-block-text", // Name of the block with a required name space
	{
		title: "Faktaruta",
		description: "Visa Faktaruta blocken",
		icon: "button", // Icon, from WP icons
		category: "qteblocks",

		attributes: {
			title: {
				type: "string",
				default: "",
			},
			content: {
				type: "string",
				default: "",
			},
			image: {
				type: "string",
				default: "",
			},
		},

		edit(props) {
			var attributes = props.attributes;

			return (
				<>
					<InspectorControls>
						<Panel>
							<PanelBody
								title="Blockinställningar"
								icon={<Icon icon="admin-generic" />}
								initialOpen={true}
							>
								<PanelRow>
									<TextControl
										label="Titel"
										value={attributes.title}
										onChange={(value) => props.setAttributes({ title: value })}
									/>
								</PanelRow>
								<PanelRow>
								<RichText
									label='Innehåll'
									tagName="div"
									placeholder={__("Enter your content here...")}
									value={attributes.content}
									onChange={(value) => props.setAttributes({ content: value })}
									style={{ border: "1px solid gray", padding: "2px" }}
								/>
								</PanelRow>

								<PanelRow>
								<MediaUpload
										label='Bild'
										onSelect={(media) => {
											props.setAttributes({
												image: media.url,
											});
										}}
										type="image"
										value={attributes.image}
										render={({ open }) => (
											<div>
												{ attributes.image == "" && <Button variant="secondary" onClick={ open }>Ladda upp bild</Button> }

												{ attributes.image &&
												    <>
														<Button variant="link" onClick={ open }>
															<img src={ attributes.image } />
														</Button>
														<Button variant="secondary" onClick={ () => props.setAttributes({ image: "" }) }>Ta bort bild</Button>
													</>
												}
											</div>
										)}>
									</MediaUpload>
								</PanelRow>

							</PanelBody>
						</Panel>
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/post-pink-block-text"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
